import { request } from '@/shared/api/request'

export const getStaffingBranches = ({data, params}) => request({ url: `staff/orgs`, method: 'POST', data: data, params })